import { isMobile, moveSite } from './js-helpers.js';

const addToCart = document.getElementById('add-to-cart');

const formatItem = item => {
	return `
		<figure
			class="card-item"
			data-id="${item.id}"
		>

			<a class="card-item-link"
				href="${item.url.includes('?') ? item.url.split('?')[0] : item.url}"
			></a>

			<div class="card-item-thumbnail ratio-item">

				<img
					class="thumb lazyload"
					src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
					width="100%"
					height="auto"
					data-src="${item.image}"
					data-srcset="
						${item.image}&width=320 320w,
						${item.image}&width=480 480w,
						${item.image}&width=640 640w,
						${item.image}&width=960 960w,
						${item.image}&width=1280 1280w,
						${item.image}&width=1600 1600w,
						${item.image}&width=1920 1920w
					"
					data-sizes="auto"
					alt="SIAN, item: ${item.product_title} (thumbnail)"
				/>

			</div>

			<span class="card-item-title">
				${item.product_title} × <span class="card-item-title-quantity">${item.quantity}</span>
			</span>

			${item.variant_title == null ? `` : `
				<span class="card-item-variant font-sans-small">
					${item.variant_title}
				</span>
			`}

			<span class="card-item-price">
				${Shopify.formatMoney(item.line_price, window.theme.moneyFormat)}
			</span>

			<button
				class="card-item-remove cta-inline font-subtle"
				type="button"
			>

				<span class="cta-inline-label font-sans-small">
					Remove
				</span>

			</button>

		</figure>
	`;
};

const updateCartCounter = cart => {
	document.querySelectorAll('[data-cart-count]').forEach(el => {
		el.setAttribute('data-cart-count', cart.item_count);
	});
};

const updateCartNotice = notice => {
	document.querySelectorAll('[data-cart-alert]').forEach(el => {
		el.setAttribute('data-cart-alert', notice);
	});
};

const updateCartItems = cart => {
	const wrapper = document.getElementById('site-cart-content-items');
	if (!wrapper) return;

	const items = wrapper.querySelectorAll('.card-item');

	const cartItems = new Map();
	cart.items.forEach(item => cartItems.set(item.id, item));

	for (const item of items) {
		const id = Number(item.dataset.id);
		const cartItem = cartItems.get(id);

		if (!cartItem) {
			item.remove();

			continue;
		}

		item.querySelector('.card-item-title-quantity').textContent = cartItem.quantity;
		item.querySelector('.card-item-price').textContent =
			Shopify.formatMoney(
				cartItem.line_price, window.theme.moneyFormat
			);

		cartItems.delete(id);
	};

	for (const item of cartItems.values()) {
		wrapper.insertAdjacentHTML('afterbegin', formatItem(item));
	}
};

const updateCartTotal = cart => {
	const total = document.getElementById('site-cart-total');
	if (!total) return;

	total.textContent = Shopify.formatMoney(
		cart.items_subtotal_price, window.theme.moneyFormat
	);
};

let addingItem = false;

const addCartItem = async form => {
	if (addingItem) return;
	addingItem = true;

	try {
		const variant =
			form.querySelector('select[name="id"]') ||
			form.querySelector('input[name="id"][type="hidden"]');

		document.body.classList.add('transition');

		addToCart.disabled = true;
		addToCart.dataset.state = 'adding';

		updateCartNotice('adding');

		let getCart = await fetch('/cart.js');
		let cart = await getCart.json();
		let item = cart.items?.find(item => item.id == variant.value);

		const stock = Number(variant.dataset.stockAmount) || 0;
		const policy = variant.dataset.stockPolicy || 'deny';
		const quantity = item ? item.quantity : 0;

		if (policy !== 'continue' && stock > 0 && quantity >= stock) {
			// await delay(500);

			addToCart.disabled = true;
			addToCart.dataset.state = 'sold';

			updateCartNotice(cart.items.length > 0 ? 'active' : 'inactive');

			return;
		}

		const postItem = await fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			body: new FormData(form),
		});

		item = await postItem.json();
		if (item.status && item.status !== 200) {
			addToCart.disabled = true;
			addToCart.dataset.state = 'sold';

			updateCartNotice(cart.items.length > 0 ? 'active' : 'inactive');

			return;
		}

		getCart = await fetch('/cart.js');
		cart = await getCart.json();

		addToCart.disabled = true;
		addToCart.dataset.state = 'added';

		updateCartCounter(cart);
		updateCartItems(cart);
		updateCartNotice('active');
		updateCartTotal(cart);

		await moveSite('right');
	} catch (error) {
		console.error('Error:', error);

		addToCart.disabled = true;
		addToCart.dataset.state = 'sold';

		updateCartNotice(cart.items.length > 0 ? 'active' : 'inactive');
	} finally {
		document.body.classList.remove('transition');

		addingItem = false;
	}
};

const removeCartItem = async item => {
	try {
		document.body.classList.add('transition');

		await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			body: `updates[${item.dataset.id}]=0`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Accept': 'application/json'
			}
		});

		const getCart = await fetch(window.Shopify.routes.root + 'cart.js');
		const cart = await getCart.json();

		updateCartCounter(cart);
		updateCartItems(cart);
		updateCartTotal(cart);

		if (cart.items.length === 0) {
			updateCartNotice('inactive');

			await moveSite('left');
		}
	} catch (error) {
		console.error('Error:', error);
	} finally {
		document.body.classList.remove('transition');
	}
};

document.querySelector('form[action="/cart/add"]')?.addEventListener('submit', event => {
	event.preventDefault();

	addCartItem(event.currentTarget);
});

document.addEventListener('click', event => {
	const btn = event.target.closest('.card-item-remove');
	if (!btn) return;

	removeCartItem(btn.closest('.card-item'));
});
